/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner
     */
    pages?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner
     */
    subtype?: string;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'pages': !exists(json, 'pages') ? undefined : json['pages'],
        'subtype': !exists(json, 'subtype') ? undefined : json['subtype'],
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSON(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'size': value.size,
        'pages': value.pages,
        'subtype': value.subtype,
    };
}

